module.exports = __webpack_public_path__ + "img/QASH.ade43478.svg";